










import { Component, Vue, Watch } from "vue-property-decorator";
import { IRoute } from "@/@types/routes/routes";
import { IVirtualRooma } from "@/@types/hotel/virtual_rooms";
import { auth } from "@/config/host.config";

import OrderReasonModal from "@/components/tables/orders/reason/order-reason-modal.vue";

@Component({
  name: "OrderProcessing",
  components: { OrderReasonModal },
})
export default class OrderProcessing extends Vue {
  routeOrders: Array<string> = [];
  route = "";

  vrooms: Array<IVirtualRooma> = [];

  changeRoute(route: string): void {
    this.route = route;
    this.$router.push(route);
  }

  @Watch("$route.path")
  updateRouteName(): void {
    const route = this.$route.name;
    this.route = route ? route : "";
  }

  createRoutes(): void {
    const routes: Array<IRoute> = this.$store.getters.ROUTER_STATE;
    const route = routes.find((el: IRoute) => el.name == this.$options.name);
    if (!routes.length || !route) {
      this.routeOrders.push("AdministrationServers");
      return;
    }
    route.children.forEach((r) => this.routeOrders.push(r));
    this.route = this.routeOrders[0];
  }

  async getVrooms(): Promise<void> {
    const uri = auth.virtual_rooms;
    const params = { "match[deleted][value]": false, "match[show]": true };

    try {
      const res = await this.$axios.get(uri, { params });
      if (res.status === 200) this.vrooms = res.data;
    } catch (e) {
      console.log(e);
    }
  }

  adjustViewportHeight(): void {
    document.documentElement.style.setProperty(
      "--app-height",
      `${window.innerHeight}px`
    );
  }

  created(): void {
    document.documentElement.setAttribute("data-bs-theme", "dark");
  }

  mounted(): void {
    this.$nextTick(() => this.createRoutes());
    this.getVrooms();
    this.$nextTick(() => {
      this.adjustViewportHeight();
      window.addEventListener("orientationchange", this.adjustViewportHeight);
    });

    if (this.$getRight("getMenu")) return;
    if (this.$getRight("getAllExcursions")) {
      this.$router.push({ name: "Excursion" });
      return;
    }
    if (this.$getRight("getAllGallery")) {
      this.$router.push({ name: "Gallery" });
      this.updateRouteName();
    }
  }

  beforeDestroy(): void {
    document.documentElement.setAttribute("data-bs-theme", "light");
  }
}
